/**
 * @description Не стоит использовать пусть бэк присылает отображать или нет что-то
 */
export const LEVEL_TRAVEL_OPERATOR_ID = 78;
